import { QueryKey } from '@tanstack/react-query';
import DomainService from 'services/domainService';
import { Domain } from 'types/domain';

const getDomainCode = async (
  { queryKey }: { queryKey: QueryKey },
  getAuthToken: () => Promise<string>
): Promise<Domain | undefined> => {
  const token = await getAuthToken();

  const agencyId = queryKey[1] as string;
  const service = new DomainService(token);

  const result = await service.domainService.get('GetAgencyCode', { agencyId });

  return result.data;
};

export default getDomainCode;
